import PropTypes from 'prop-types';
import { CardContent } from '@mui/material';
import { StatCardStyled, StatNumber, StatLabel } from './DashboardStyles';

export function StatCard({ number, label }) {
  return (
    <StatCardStyled>
      <CardContent sx={{ padding: 0, '&:last-child': { paddingBottom: 0 } }}>
        <StatNumber>{number}</StatNumber>
        <StatLabel>{label}</StatLabel>
      </CardContent>
    </StatCardStyled>
  );
}

StatCard.propTypes = {
  number: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  label: PropTypes.string.isRequired,
};
